<template>
  <el-popover
    placement="left"
    :open-delay="100"
    width="600"
    trigger="hover"
    @show="setMaxHeight"
  >
    <div class="ops-viewer">
      <div class="summary">
        <div class="info-item">
          <p>{{ totalStock }}</p>
          <p>总库存</p>
        </div>
        <div class="info-item">
          <p>{{ sumDemand }}</p>
          <p>总需求</p>
        </div>
        <div class="info-item">
          <p>{{ purchasing }}/{{ lading }}</p>
          <p>采购中/预入库</p>
        </div>
        <div class="info-item">
          <p>{{ waitPurchase }}</p>
          <p>待采</p>
        </div>
      </div>
      <div class="order-info">
        <div class="section-title">相关订单</div>
        <data-table :columns="orderColumns" :list="opsInfo.orderDemand" :max-height="maxHeight"></data-table>
      </div>
      <div v-if="opsInfo.purchaseInfo && opsInfo.purchaseInfo.length" class="order-info">
        <div class="section-title">相关采购</div>
        <data-table :columns="opsColumns" :list="opsInfo.purchaseInfo"></data-table>
      </div>
      <div v-if="opsInfo.stockInfo && opsInfo.stockInfo.length" class="order-info">
        <div class="section-title">库存明细</div>
        <data-table :columns="stockColumns" :list="opsInfo.stock"></data-table>
      </div>
    </div>
    <div
      slot="reference"
      class="order-ops-status"
      :class="{
        'stock-enough': stockEnough === 2,
        'part-enough': stockEnough === 1,
        'need-purchase': waitPurchase > 0,
        'on-way': waitPurchase === 0 && stockEnough === 0
      }"
      @click="visible=!visible"
    >
      <template v-if="stockEnough === 1 || stockEnough === 2">
        <div v-if="enoughShop.length > 1" class="shop-enough">
          多仓
        </div>
        <div v-else class="shop-enough">
          {{ enoughShop[0] }}
        </div>
      </template>
      {{ stockEnough | stockEnoughFmt }}
    </div>
  </el-popover>
</template>
<script>
import DataTable from '@/components/DataTable.vue'
import moment from 'moment'
import _ from 'lodash'
import CopyText from '@/libs/copyer'

export default {
  name: 'OpsViewPopover',
  components: { DataTable },
  filters: {
    stockEnoughFmt (val) {
      switch (val) {
        case 0 : return '库存不足'
        case 1 : return '选择发货'
        case 2 : return '可以发货'
        case 3 : return '调配发货'
        default : return ''
      }
    }
  },
  props: {
    opsInfo: {
      type: Object,
      default () {
        return {
          orderColumns: [],
          opsColumns: [],
          stockColumns: [],
          partCode: undefined,
          brandCode: undefined,
          stock: [],
          orderDemand: [],
          purchaseInfo: []
        }
      }
    },
    currentOrderId: {
      type: Number,
      default () {
        return 0
      }
    },
    waitDelivery: {
      type: Number,
      default () {
        return 0
      }
    },
    position: {
      type: String,
      default () {
        return 'left'
      }
    }
  },
  data () {
    return {
      maxHeight: '100px',
      visible: false
    }
  },
  computed: {
    totalStock () {
      return _.sumBy(this.opsInfo.stock, o => o.quantity)
    },
    sumDemand () {
      return _.sumBy(this.opsInfo.orderDemand, o => o.quantity - o.quantityDelivered)
    },
    currentOrderDemand () {
      if (this.opsInfo && this.opsInfo.orderDemand && this.opsInfo.orderDemand.length && this.currentOrderId) {
        const currentOrder = _.find(this.opsInfo.orderDemand, o => o.orderId === this.currentOrderId)
        if (currentOrder) {
          return currentOrder.quantity - currentOrder.quantityDelivered
        }
        return 0
      } else {
        return 0
      }
    },
    purchasing () {
      return _.sumBy(this.opsInfo.purchaseInfo, o => o.count - o.ladedCount)
    },
    lading () {
      return _.sumBy(this.opsInfo.purchaseInfo, o => o.ladingCount)
    },
    waitPurchase () {
      const rst = this.sumDemand - this.totalStock - this.purchasing
      return rst > 0 ? rst : 0
    },
    repoCanDelivery () {
      const currentOrder = _.find(this.opsInfo.orderDemand, o => o.orderId === this.currentOrderId)
      return _.find(this.opsInfo.stock, o => o.quantity > (currentOrder.quantity - currentOrder.quantityDelivered))
    },
    stockEnough () {
      if (_.some(this.opsInfo.stock, o => o.state === 2)) {
        return 2
      }
      if (_.some(this.opsInfo.stock, o => o.state === 1)) {
        return 1
      }
      if (this.totalStock >= this.currentOrderDemand) {
        return 3
      }
      return 0
    },
    enoughShop () {
      return _.filter(this.opsInfo.stock, o => o.state === 1 || o.state === 2).map(t => t.repoName.slice(0, 2))
    }
  },
  beforeCreate () {
    const ctx = this
    this.orderColumns = [
      {
        name: '订单编号',
        code: 'orderSn',
        flexWidth: 3,
        cellComponent: {
          computed: {
            isCurrent () {
              return this.row.orderId === ctx.currentOrderId
            }
          },
          methods: {
            redirect () {
              if (!this.isCurrent) {
                window.open(`/order/detail/${this.row.orderId}`, '__blank')
              }
            }
          },
          template: `
            <div :class="{ 'is-current': isCurrent }">
              <el-button type="text" size="mini" @click="redirect">{{row.orderSn}}</el-button>
            </div>
          `
        }
      },
      {
        name: '支付时间',
        code: 'timePay',
        flexWidth: 2,
        cellComponent: {
          template: `
            <div>{{ row.timePay | dateTimeFmt }}</div>
          `,
          filters: {
            dateTimeFmt (val) {
              return moment(val).format('YYYY/MM/DD HH:mm')
            }
          }
        }
      },
      {
        name: '需求量',
        code: 'quantity',
        flexWidth: 1,
        cellComponent: {
          template: `
            <div>
              {{ row.quantity }}
            </div>
          `
        }
      },
      {
        name: '已发',
        code: 'quantityDelivered',
        flexWidth: 1,
        renderFunc (val) {
          return val || 0
        }
      },
      {
        name: '类型',
        flexWidth: 1,
        code: 'priceType',
        renderFunc (val) {
          return val === 1 ? '急件' : '常规件'
        }
      }
    ]
    this.opsColumns = [
      {
        name: '采购单',
        code: 'opsSn',
        flexWidth: 2.8,
        cellComponent: {
          template: `
            <a href="javascript:void(0)" @click="doCopyLink">{{ row.opsSn }}</a>
          `,
          methods: {
            doCopyLink () {
              CopyText(this.row.opsSn).then(() => {
                this.$message.success('已复制到剪贴板')
              })
            }
          }
        }
      },
      {
        name: '供应商',
        code: 'supplierName',
        flexWidth: 1.8,
        cellComponent: {
          template: `
            <ellipsis-text :content="row.supplierName">{{ row.supplierName }}</ellipsis-text>
          `
        }
      },
      {
        name: '采购时间',
        code: 'createdAt',
        flexWidth: 1.7,
        cellComponent: {
          template: `
            <div>{{ row.createdAt | shortTimeFmt }}</div>
          `,
          filters: {
            shortTimeFmt (val) {
              return moment(val).format('YYYY-MM-DD HH:mm')
            }
          }
        }
      },
      {
        name: '采购量',
        code: 'count',
        flexWidth: 1
      },
      {
        name: '已到货',
        code: 'ladedCount',
        flexWidth: 1,
        renderFunc (val) {
          return val || 0
        }
      },
      {
        name: '预入库',
        code: 'ladingCount',
        flexWidth: 1,
        renderFunc (val) {
          return val || 0
        }
      }
    ]
    this.stockColumns = [
      {
        name: '仓库',
        code: 'repoName',
        flexWidth: 1
      },
      {
        name: '剩余数量',
        code: 'quantity',
        flexWidth: 1
      },
      {
        name: '状态',
        code: 'state',
        cellComponent: {
          template: `
            <div :class="['repo-state-' + row.state]">
              {{ row.state | stateFmt }}
            </div>
          `,
          filters: {
            stateFmt (val) {
              switch (val) {
                case 0 : return '库存不足'
                case 1 : return '选择发货'
                case 2 : return '可以发货'
                default: return '--'
              }
            }
          }
        }
      },
      {
        name: '操作',
        code: 'stockInInfos',
        flexWidth: 1,
        cellComponent: {
          template: `
            <div>
              <el-popover
                v-if="row.quantity"
                trigger="hover">
                <table class="stockin-info-table">
                  <tr>
                    <td>供应商</td>
                    <td>到货时间</td>
                    <td>剩余数量</td>
                  </tr>
                  <tr v-for="stockIn in row.stockInInfos" :key="stockIn.id">
                    <td>
                      {{
                        stockIn.supplierName
                      }}
                    </td>
                    <td>
                      {{
                        stockIn.createTime | shortTimeFmt
                      }}
                    </td>
                    <td>
                      {{
                        stockIn.quantity - stockIn.qtySold
                      }}
                    </td>
                  </tr>
                </table>
                <el-button slot="reference" type="text" size="mini">
                  查看
                </el-button>
              </el-popover>
              <el-button v-if="false" v-uac="'stockTransfer.startTransfer'" style="margin-left: 10px" type="text" size="mini" @click="handleTransfer(row)">调拨</el-button>
            </div>
          `,
          filters: {
            shortTimeFmt (val) {
              return moment(val).format('YYYY-MM-DD HH:mm')
            }
          },
          methods: {
            handleTransfer (row) {
              const { brandCode, repositoryId, partCode, partName, quantity } = row
              const transferModal = {
                brandCode,
                repoFrom: repositoryId,
                partCode,
                partName,
                stockQty: quantity,
                quantity: quantity,
                quality: 1
              }
              this.modal('StockTransferModal', transferModal).promise.then(() => {
                this.$store.dispatch('updateTransferingCount')
              })
            }
          }
        }
      }
    ]
  },
  methods: {
    setMaxHeight () {
      this.maxHeight = '180px'
    }
  }
}
</script>

<style lang="stylus">
.order-ops-status
  border 1px solid #ff3300
  color #ff3300
  display: inline-block
  padding: 2px 26px
  position relative
  cursor default
  .shop-enough
    color: #fff
    position: absolute
    display: block
    padding: 0 4px
    font-size: 12px
    transform: scale(0.8)
    top: -2px
    left: -4px
  &.stock-enough
    color #33CC00
    border-color #33CC00
    &.shop-enough
      color: #C0FCAC
      border-color: #C0FCAC
  &.part-enough
    color #BCD333
    border-color #BCD333
    .shop-enough
      background: #BCD333
  &.need-purchase
    &:after
      content: '\5f85\91c7'
      background-color: #E6A23C
      color: #fff
      position: absolute
      display: block
      padding: 0 4px
      font-size: 12px
      transform: scale(0.8)
      top: -2px
      right: -4px
  &.on-way
    &:after
      content: '\5728\9014'
      background-color: #ff3300
      color: #fff
      position: absolute
      display: block
      padding: 0 4px
      font-size: 12px
      transform: scale(0.8)
      top: -2px
      right: -4px
.ops-viewer
  display: flex
  flex-direction: column
  height auto
  font-size: 12px
  overflow: hidden
  .summary
    display: flex
    flex-direction: row
    .info-item
      flex 1
      padding 6px
      text-align: center
      border 1px solid #d4d4d4
      + .info-item
        margin-left: 10px
      > p
        margin 0
        line-height: 1.4
        &:first-child
          font-weight: 600
          font-size: 14px
        &:nth-child(2)
          font-size: 12px
          color #9c9c9c
  .order-info
    padding-top: 6px
    .section-title
      position relative
      font-weight: 600
      padding-left: 10px
      &::before
        position: absolute
        content: '\20'
        background #ff3300
        width: 4px
        height 12px
        left 0
        top 0
        bottom 0
        margin-top: auto
        margin-bottom: auto
    .is-current
      &:before
        content: '\5f53\524d\8ba2\5355'
        border 1px solid #ff3300
        color #ff3300
        padding: 0 2px
    .base-data-table
      .body-wraper
        border-bottom: none
      td
        padding 2px 4px
.stockin-info-table
  td
    border 1px solid #d4d4d4
    padding 2px
</style>
